import styled from '@emotion/styled';
import css from '@styled-system/css';

const SystemModalContent = styled('div')(
  css({
    padding: 'big',
    paddingTop: '44px',
    paddingBottom: '1x_big',
  })
);

export default SystemModalContent;
